<template>
  <div>
    <!--------------------------->
    <!-- Machines Listing Page -->
    <!--------------------------->
    <h1 style="text-align: center;"><br/><icon name="cog" scale="5"></icon><br/>GENERAL SETTINGS</h1>
    <br/>&nbsp;
    <div class="col-md-12">
      <div class="row justify-content-center " align="center">
        <div class="col-md-5 col-sm-5 shadows" style="margin: 25px 10px 25px 10px; padding: 25px 5px 25px 5px;">
          <div style="margin-bottom: 15px;"><icon name="calendar" scale="4"></icon></div>
          <h5><strong>Attendance Cut Off Date</strong></h5>
          <p>Please specify the date below before which shift plans cannot be changed. <br/></p>
          <input type="date" name="date"  v-model="updateHRSettingsForm.cutOffDate">
          <hr/>
          <button class="btn btn-success" @click="updateHRSettings()">Update Settings</button>
        </div>

        <div class="col-md-6 col-sm-6 shadows" style="margin: 25px 10px 25px 10px; padding: 25px 5px 25px 5px;">
          <div style="margin-bottom: 15px;"><icon name="refresh" scale="4"></icon></div>
          <h5><strong>Shift Plan Visibility & Cycles</strong></h5>
          <p>Please specify the visibility start date and end date. <br/></p>
          &nbsp; &nbsp; &nbsp; &nbsp;<strong>Start</strong> &nbsp; &nbsp;
          <input type="date" name="date"  v-model="updateHRSettingsForm.visibilityStart">
          &nbsp; &nbsp; &nbsp; &nbsp;<strong>End</strong> &nbsp; &nbsp;
          <input type="date" name="date"  v-model="updateHRSettingsForm.visibilityEnd">
          &nbsp; &nbsp; &nbsp; &nbsp;<br/><strong style="text-align: center; margin-top: 7px;">Cycles</strong> &nbsp; &nbsp;
          <input style="margin-top: 7px;" type="text" v-model="updateHRSettingsForm.cycles">
          <hr/>
          <button class="btn btn-success" @click="updateHRSettings()">Update Settings</button>
        </div>

      </div>
      <br/>
    </div>
    <br/>&nbsp;
  </div>
</template>

<script>
    import axios from 'axios'
    import router from './../../../router'
    import {Form, Errors} from '@/components/validations/forms';
    import {mixin} from '@/mixins/mixins';

    export default {
        mixins: [mixin],
        name: 'AlertsZone',
        data () {
            return {
                settingsHR: this.$store.getters['environment/getSettingsHR'],
                updateHRSettingsForm: new Form({
                    cutOffDate: null,
                    visibilityStart: null,
                    visibilityEnd: null,
                    cycles: null,
                }),
            }
        },

        methods: {
            updateHRSettings(){
                if(this.updateHRSettingsForm.cutOffDate && this.updateHRSettingsForm.visibilityStart && this.updateHRSettingsForm.visibilityEnd && this.updateHRSettingsForm.cycles){
                    this.$store.dispatch('environment/updateSettingsHR', this.updateHRSettingsForm)
                        .then(response => {
                            this.loadSettings();
                            this.$snotify.success('System Configuration Updated!');
                        })
                        .catch(error => {
                            this.machineUpdateForm.onFail(error);
                            this.$snotify.error(this.updateCutOffDateForm.errors.error.message, this.updateCutOffDateForm.errors.error.title);
                        })
                } else{
                    this.$snotify.error('Please fill in all the details.');
                }

            },

            loadSettings() {
                // Load Settings
                this.$store.dispatch('environment/fetchSettingsHR')
                    .then(response => {
                        this.updateHRSettingsForm.cutOffDate = this.findCutOffDate();
                        this.updateHRSettingsForm.visibilityStart = this.findVisibilityStart();
                        this.updateHRSettingsForm.visibilityEnd = this.findVisibilityEnd();
                        this.updateHRSettingsForm.cycles = this.findCycles().value;
                    })
            },
        },

        computed: {
            //
        },

        created() {
            this.loadSettings();
        },

    }
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/settings/hr/general.vue